import { createFileRoute, redirect } from '@tanstack/react-router';

/** Staff start the day from what is stuck (UX review §1.1). */
export const Route = createFileRoute('/_staff/staff/')({
  beforeLoad: () => {
    throw redirect({ to: '/staff/ops' });
  },
});
